// extracted by mini-css-extract-plugin
export default {"imageWrapper":"IJ-z","videoWrapper":"JJ-z","twoColumnImage":"KJ-z","imageCarouselBtn":"LJ-z","carouselNextBtn":"MJ-z","carouselPrevBtn":"NJ-z"};